export const moduleRoutes = {
    getUsers: 'tsc/users/',
    getProjects: 'tsc/projects/',
    getWorkbooks: 'tsc/workbooks/',
    getGroups: 'tsc/groups/',
    getLinks: 'tableaulinks/',
};
